import { useEffect, useState } from "react";
import "./OffersStrip.css";
import { getPublicCoupons } from "../../data/modules/student-module";

function dealText(c) {
  if (c.discountType === "percentage") {
    let t = `${c.discountValue}% OFF`;
    if (c.maxDiscount) t += ` up to ₹${c.maxDiscount}`;
    return t;
  }
  return `₹${c.discountValue} OFF`;
}

function savings(c, amount) {
  if (!amount || amount <= 0) return null;
  if (c.minOrderValue && amount < c.minOrderValue) return null;
  let d = 0;
  if (c.discountType === "percentage") {
    d = (amount * c.discountValue) / 100;
    if (c.maxDiscount) d = Math.min(d, c.maxDiscount);
  } else {
    d = Math.min(c.discountValue, amount);
  }
  d = Math.round(d * 100) / 100;
  return d > 0 ? d : null;
}

export default function OffersStrip({
  amount,
  onApply,
  appliedCode,
  copyMode = false,
  title = "Available Offers",
}) {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const list = await getPublicCoupons();
        if (alive) setCoupons(Array.isArray(list) ? list : []);
      } catch {
        if (alive) setCoupons([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (loading || !coupons.length) return null;

  const copy = (code) => {
    try {
      navigator.clipboard?.writeText(code);
    } catch {
      // ignore
    }
    setCopied(code);
    setTimeout(() => setCopied(""), 1500);
  };

  return (
    <div className="offers-strip">
      <div className="offers-strip-head">
        <span className="offers-strip-title">{title}</span>
      </div>
      <div className="offers-strip-track">
        {coupons.map((c) => {
          const saved = savings(c, amount);
          const isApplied =
            appliedCode && appliedCode.toUpperCase() === String(c.code).toUpperCase();
          return (
            <div className={`offer-card${isApplied ? " applied" : ""}`} key={c.code}>
              <div className="offer-card-deal">{dealText(c)}</div>
              {c.name ? <div className="offer-card-name">{c.name}</div> : null}
              {c.description ? (
                <div className="offer-card-desc">{c.description}</div>
              ) : null}
              {saved != null ? (
                <div className="offer-card-save">You save ₹{saved}</div>
              ) : c.minOrderValue ? (
                <div className="offer-card-min">On orders above ₹{c.minOrderValue}</div>
              ) : null}
              <div className="offer-card-foot">
                <span className="offer-card-code">{c.code}</span>
                {copyMode ? (
                  <button
                    type="button"
                    className="offer-card-btn"
                    onClick={() => copy(c.code)}
                  >
                    {copied === c.code ? "Copied!" : "Copy code"}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="offer-card-btn"
                    disabled={isApplied}
                    onClick={() => onApply && onApply(c.code)}
                  >
                    {isApplied ? "Applied" : "Apply"}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
